<script>
	import { assetUrl, linkToAppointment, startTime, language, prefix, i18n, mainStep, questions } from './stores.js';
	import { onMount, onDestroy } from 'svelte';
	import { fade, scale, slide, fly } from 'svelte/transition';
	import { quartIn, quintIn } from 'svelte/easing';

	// import Imagepreloader from './Imagepreloader.svelte';

	import Icons from './Molecules/Icons.svelte';
	import Icon from './Atoms/Icon.svelte';

	import StepIndicator from './Molecules/StepIndicator.svelte';
	import Question from './Molecules/Question.svelte';
	import Results from './Results.svelte';


	export let assets;
	export let languageCode;
	export let i18nSetName;
	export let demoAppointmentLink;

	let mainContainer;

	onMount(() => {
		i18n.set(window[i18nSetName]);
		assetUrl.set(assets);
		language.set(languageCode);
		linkToAppointment.set(demoAppointmentLink);
		mainStep.set(0);
	});


	// const unsubscribe = questions.subscribe(loadedQuestions => {
    //     console.log(loadedQuestions);
	// 	loadedQuestions.forEach( (q) => {
	// 		let extendQuestion = q;
	// 		extendQuestion.answers.forEach( (extendAnswer) => { 
	// 			extendAnswer["selected"] = false;
	// 		});
	// 		savedAnswers.push(extendQuestion);
	// 	});
	// 	console.log(savedAnswers);
    // });

	// onDestroy(() => {
	// 	// 4. We make sure to unsubscribe from the store once the component has been destroyed.
	// 	unsubscribe();
	// });
	
</script>

<div>
    <Icons />
	<div bind:this={mainContainer} class="{$prefix}-app-container">
		<div class="{$prefix}-step-container">
			<StepIndicator />

			{#if $mainStep == $questions.length-1  }
				<Results />
			{:else}
				<Question />
			{/if}
		</div>
		<!-- <Imagepreloader assetUrl={assets} /> -->
	</div>

</div>

<style type="text/scss">
	@import './sass/vars';

	:global(.#{$prefix}-primary) {
		color: $primary;
	}

	.#{$prefix}-app-container { 
		background-color: $background-gray-light;
		width: 100%;
		min-height: 800px;
		overflow: hidden;

        @media only screen and (max-width: $breakpoint-medium) {
			min-height: 550px;
        }

	}
	.#{$prefix}-results-container { 
		background-color: $background-gray-light;
		width: 100%;
		padding: 2rem 4rem;
    }

</style>
